/**
 * PulseAI brand mark: a symmetric 7-bar "pulse" glyph.
 * Geometry is shared between the React component (Logo.tsx) and this raw-markup
 * builder (used by exportService, which assembles plain HTML strings rather than JSX).
 */
const BAR_HEIGHTS = [12, 20, 26, 32, 26, 20, 12];
const BAR_WIDTH = 5;
const BAR_GAP = 2;
const VIEWBOX_HEIGHT = 32;

export function buildLogoBars(): { x: number; y: number; width: number; height: number }[] {
  return BAR_HEIGHTS.map((height, index) => ({
    x: index * (BAR_WIDTH + BAR_GAP) + 1,
    y: (VIEWBOX_HEIGHT - height) / 2,
    width: BAR_WIDTH,
    height,
  }));
}

const VIEWBOX_WIDTH = BAR_HEIGHTS.length * (BAR_WIDTH + BAR_GAP) + 1;

/** Raw `<svg>` markup for embedding directly into generated HTML strings (exports, print). */
export function LOGO_SVG_MARKUP(color = '#141b4d', size = 28): string {
  const bars = buildLogoBars()
    .map(
      (bar) =>
        `<rect x="${bar.x}" y="${bar.y}" width="${bar.width}" height="${bar.height}" rx="${bar.width / 2}" fill="${color}" />`,
    )
    .join('');
  const aspect = VIEWBOX_HEIGHT / VIEWBOX_WIDTH;
  return `<svg width="${size}" height="${Math.round(size * aspect)}" viewBox="0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}" fill="none" xmlns="http://www.w3.org/2000/svg">${bars}</svg>`;
}

export const LOGO_VIEWBOX = `0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`;
